import Icon from "@ant-design/icons/lib/components/Icon";

const SalesReturn = () => (
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M14.12,30c-.65-.09-1.3-.16-1.94-.28a15,15,0,0,1-7.54-3.95l-.24-.21s0,0-.08,0L1.53,28.46V21H9L6.46,23.39a11.71,11.71,0,0,0,12.16,3c5.34-1.85,8-5.79,8.43-11.41H30c0,.51,0,1-.09,1.49a14.8,14.8,0,0,1-4.62,9.38,14.63,14.63,0,0,1-8.55,4l-.81.11Z" />
        <path d="M0,14.06c.07-.54.13-1.08.23-1.62A14.78,14.78,0,0,1,5.75,3.22,14.47,14.47,0,0,1,13.5.07,14.66,14.66,0,0,1,24.22,3.25c.49.38.94.8,1.44,1.23l2.8-2.95V9H21l2.49-2.36A11.87,11.87,0,0,0,12.05,3.36,12.11,12.11,0,0,0,3,15H0Z" />
        <path d="M10.51,18h3a2.56,2.56,0,0,0,0,.27,1.61,1.61,0,0,0,1.59,1.21A1.62,1.62,0,0,0,16.49,18a1.48,1.48,0,0,0-1.43-1.45,4.49,4.49,0,0,1-1.79-8.62.3.3,0,0,0,.22-.35c0-.43,0-.86,0-1.29,0-.21.06-.26.27-.26h2.45c.25,0,.3.09.29.3,0,.41,0,.82,0,1.23a.34.34,0,0,0,.26.38,4.32,4.32,0,0,1,2.74,3.87V12H16.57a5.68,5.68,0,0,0-.4-.82,1.41,1.41,0,0,0-1.77-.53,1.45,1.45,0,0,0-.88,1.59,1.6,1.6,0,0,0,1.42,1.27,4.64,4.64,0,0,1,2.86.95,4.49,4.49,0,0,1-1.07,7.66.33.33,0,0,0-.24.37c0,.44,0,.88,0,1.32,0,.16-.06.22-.22.22Q15,24,13.7,24c-.17,0-.21-.07-.21-.23,0-.43,0-.86,0-1.29a.37.37,0,0,0-.28-.4,4.3,4.3,0,0,1-2.72-3.93A.92.92,0,0,1,10.51,18Z" />
      </g>
    </g>
  </svg>
);

const upi = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill-rule="evenodd"
    fill="currentColor"
  >
    <path d="M22.41 16.47l-6.03 21.475 21.407.15 5.88-21.625h5.427l-7.05 25.14c-.27.96-1.298 1.74-2.295 1.74H12.31c-1.664 0-2.65-1.3-2.2-2.9l6.724-23.98zm66.182-.15h5.427l-7.538 27.03h-5.58zM49.698 27.582l27.136-.15 1.81-5.707H51.054l1.658-5.256 29.4-.27c1.83-.017 2.92 1.4 2.438 3.167L81.78 29.49c-.483 1.766-2.36 3.197-4.19 3.197H53.316L50.454 43.8h-5.28z" />
  </svg>
);

const credit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0"
    y="0"
    viewBox="0 0 64 64"
    fill="currentColor"
  >
    <g>
      <path
        d="M18 25v-.382l.624.312A11.357 11.357 0 0 0 29.378 40h1.244a11.362 11.362 0 0 0 8.256-19.185A2.935 2.935 0 0 0 38.234 18a2.994 2.994 0 0 0 0-4A3 3 0 0 0 36 9a.964.964 0 0 0-.152.012l-1.374.211 1.5-5.98a1 1 0 0 0-1.525-1.075l-2.172 1.445-1.446-2.168a1 1 0 0 0-1.7.051L27.6 4.124 25.428 3.1a1 1 0 0 0-1.4 1.146l.572 2.281L18 9.461V9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1H1v2h7v12H1v2h7a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1Zm22 3.622A9.389 9.389 0 0 1 30.622 38h-1.244a9.365 9.365 0 0 1-8.949-12.167l2.124 1.067A1 1 0 0 0 23 27h4a3 3 0 0 0 3 3 1 1 0 1 1-1 1h-2a3 3 0 0 0 2 2.816V36h2v-2.184A2.993 2.993 0 0 0 30 28a1 1 0 0 1-1-1h5a3 3 0 0 0 2.789-4.1 2.994 2.994 0 0 0 .909-.426A9.413 9.413 0 0 1 40 28.622ZM27.572 6.324a1 1 0 0 0 1.291-.4l1.192-2.039 1.113 1.669a1 1 0 0 0 1.387.277l.847-.565-1.071 4.287-4.732.728-1.117-4.473ZM18 11.65l7.093-3.15.522 2.089-2.767.426.3 1.976L36.063 11A1 1 0 0 1 36 13h-3v2h3a1 1 0 0 1 0 2h-3v2h3a1 1 0 0 1 0 2h-3v2h1a1 1 0 0 1 0 2H23.236L18 22.382ZM16 24h-6V10h6ZM63 48v-2h-5a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v1.6a9.313 9.313 0 0 0-6.471-2.6h-1.293a4.587 4.587 0 0 0-3.8 2H30a2.992 2.992 0 0 0-2.528 1.4l-4.951-4.18A3.752 3.752 0 0 0 16 46.751v.193a3.749 3.749 0 0 0 .963 2.51l6.287 6.985A7.713 7.713 0 0 0 28.945 59L48 59.951V62a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1h5v-2h-5V48Zm-15 9.949L29 57a5.745 5.745 0 0 1-4.264-1.9l-6.286-6.984a1.752 1.752 0 0 1-.45-1.172v-.193a1.751 1.751 0 0 1 3.069-1.151 1.091 1.091 0 0 0 .109.106l5.911 4.988A3 3 0 0 0 30 53h7v-2h-7a1 1 0 0 1 0-2h7a1 1 0 0 0 .9-.553A2.6 2.6 0 0 1 40.236 47h1.293a7.323 7.323 0 0 1 5.207 2.149A22.034 22.034 0 0 1 48 51.256ZM56 61h-6V47h6Z"
        data-original="#000000"
        class=""
      ></path>
    </g>
  </svg>
);

const RecurringCustomers = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 30 30"
  >
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          class="cls-1"
          d="M29,19.55l-.09-.07a1.74,1.74,0,0,0-.1-.19,6.64,6.64,0,0,0-2.74-2.74,6.56,6.56,0,0,0-7.54,1.06,6.91,6.91,0,0,0-2,3.18c-.08.24-.1.5.12.64a.63.63,0,0,0,.51.08.76.76,0,0,0,.32-.43,5.9,5.9,0,0,1,4.93-4.17,5.48,5.48,0,0,1,5.76,3.41,2.14,2.14,0,0,1,.05.23H26v1h4V17.39H29ZM17,26l.06,0,.13.26a6.68,6.68,0,0,0,7,3.65A6.29,6.29,0,0,0,29,26.07a11,11,0,0,0,.53-1.69.5.5,0,1,0-1-.24c0,.12-.06.26-.09.39A5.89,5.89,0,0,1,26.16,28a5.56,5.56,0,0,1-8.4-3,2.55,2.55,0,0,1-.08-.28H19.5v-1H16v3.64h1Z"
        />
        <path d="M0,26.47c.15-.47.26-1,.45-1.42a3.64,3.64,0,0,1,1.38-1.6C3,22.7,4.1,21.93,5.25,21.2A1.58,1.58,0,0,0,6,19.81a2.6,2.6,0,0,0-.61-1.95,6,6,0,0,1-1.18-2.34,1,1,0,0,0-.2-.33A1.82,1.82,0,0,1,3.52,14c0-.68,0-1.36,0-2a4.08,4.08,0,0,1,.31-.91,1.52,1.52,0,0,0,.15-.5c0-.75-.05-1.51,0-2.25a4.91,4.91,0,0,1,4.32-4.5,6.57,6.57,0,0,1,3.93.49l.19.07A14.19,14.19,0,0,1,13,2.85,4.24,4.24,0,0,1,15.58.5a8.67,8.67,0,0,1,6.3.19A4.54,4.54,0,0,1,24.52,5c0,1,0,2,0,2.92a.57.57,0,0,0,.1.34A2.46,2.46,0,0,1,25,9.62V11.5a2.43,2.43,0,0,1-1,1.94,1.43,1.43,0,0,1-1,.27A8.73,8.73,0,0,0,15,20a9.28,9.28,0,0,0,1.49,8.66l.17.25-.17,0H0Zm1,1.4H7c0-.32,0-.62,0-.93a9.19,9.19,0,0,1,.17-1.49,4.63,4.63,0,0,1,2.29-3l4.19-2.4c.11-.07.26-.16.3-.27a4.7,4.7,0,0,0,.54-2.44,1.57,1.57,0,0,0-.18-.59,12.14,12.14,0,0,1-1.5-3.32.92.92,0,0,0-.18-.34A2.13,2.13,0,0,1,12,11.55c0-.68,0-1.36,0-2a1.82,1.82,0,0,1,.2-.91,2.14,2.14,0,0,0,.28-1.37,11.42,11.42,0,0,1,0-1.17.63.63,0,0,0-.41-.7A5.84,5.84,0,0,0,7.84,5,3.8,3.8,0,0,0,5,8.42c-.08.84,0,1.7,0,2.55a.81.81,0,0,1-.18.48,1.34,1.34,0,0,0-.31.87c0,.47,0,.94,0,1.42a1,1,0,0,0,.39.88.64.64,0,0,1,.19.29A7.43,7.43,0,0,0,6.81,18a.73.73,0,0,1,.16.43c0,.46,0,.92,0,1.39a2.32,2.32,0,0,1-1.14,2.19Q4.1,23.16,2.39,24.33a3.72,3.72,0,0,0-.84.84A4,4,0,0,0,1,27.87Z" />
        <path d="M29,19.55V17.39h1v4.18H26v-1h2.23a2.14,2.14,0,0,0-.05-.23,5.48,5.48,0,0,0-5.76-3.41,5.9,5.9,0,0,0-4.93,4.17.76.76,0,0,1-.32.43.63.63,0,0,1-.51-.08c-.22-.14-.2-.4-.12-.64a6.91,6.91,0,0,1,2-3.18,6.56,6.56,0,0,1,7.54-1.06,6.64,6.64,0,0,1,2.74,2.74,1.74,1.74,0,0,1,.1.19Z" />
        <path d="M17,27.27v.92H16V25.7H19.5v.69H17.68a1.38,1.38,0,0,0,.08.2c1.21,2.44,5.42,3.46,8.4,2a4.32,4.32,0,0,0,2.27-2.35c0-.09.05-.18.09-.27a.54.54,0,0,1,.61-.3c.27,0,.44.23.35.47A5.69,5.69,0,0,1,29,27.31a6.32,6.32,0,0,1-4.72,2.62c-2.78.36-5.7-.68-7-2.49l-.13-.18Z" />
      </g>
    </g>
  </svg>
);

const NewCustomer = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 30 30"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M0,23c0-.44.08-.89.11-1.34.09-1.45.17-2.89.26-4.33,0-.12,0-.24,0-.4l5.45,3.63L4,21.54a2,2,0,0,0,.11.21,12.46,12.46,0,0,0,8.33,5.79A12.6,12.6,0,0,0,26,21.15l.27-.49a1.09,1.09,0,0,1,1.92,1.05,21.36,21.36,0,0,1-1.09,1.85,14.23,14.23,0,0,1-8,5.82,14.48,14.48,0,0,1-13.49-2.7A14.13,14.13,0,0,1,2.21,22.9c-.07-.12-.15-.23-.22-.36l-2,1Z" />
        <path d="M28,7.94,30,7l-.64,6.56L24,9.75l2-.92c-.52-.72-1-1.43-1.5-2.07a12.44,12.44,0,0,0-7.27-4.32A12.67,12.67,0,0,0,3.5,9.28c-.08.16-.16.33-.25.49a1.08,1.08,0,0,1-1.43.49,1.1,1.1,0,0,1-.53-1.45A14.24,14.24,0,0,1,3,5.9,14.79,14.79,0,0,1,9.44,1a14.58,14.58,0,0,1,7-.94A14.94,14.94,0,0,1,27.77,7.56C27.83,7.68,27.9,7.8,28,7.94Z" />
        <path d="M20.79,22.24H8.93c0-1.51-.15-3,.86-4.29A4.08,4.08,0,0,1,13,16.29c1.2,0,2.4,0,3.6,0a4.23,4.23,0,0,1,4.23,4.32C20.79,21.14,20.79,21.68,20.79,22.24Z" />
        <path d="M18.66,11.15a3.82,3.82,0,1,1-3.78-3.84A3.83,3.83,0,0,1,18.66,11.15Z" />
      </g>
    </g>
  </svg>
);

export const UpiIcon = ({ size, color, style = {}, ...props }) => (
  <Icon
    style={{
      display: "inline-block",
      width: size,
      height: size,
      color: color,
      ...style,
    }}
    component={upi}
    {...props}
  />
);

export const CreditIcon = ({ size, color, ...props }) => (
  <Icon
    style={{
      display: "inline-block",
      width: size,
      height: size,
      color: color,
    }}
    component={credit}
    {...props}
  />
);

export const NewCustomerIcon = ({ size, color, ...props }) => (
  <Icon
    style={{
      display: "inline-block",
      width: size,
      height: size,
      color: color,
    }}
    component={NewCustomer}
    {...props}
  />
);

export const RecurringCustomersIcon = ({ size, color, ...props }) => (
  <Icon
    style={{
      display: "inline-block",
      width: size,
      height: size,
      color: color,
    }}
    component={RecurringCustomers}
    {...props}
  />
);

export const SalesReturnIcon = ({ size, color, ...props }) => (
  <Icon
    style={{
      display: "inline-block",
      width: size,
      height: size,
      color: color,
    }}
    component={SalesReturn}
    {...props}
  />
);

const TotalSales = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 30 30"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M30,20.31a5.64,5.64,0,0,1-.63.66c-3.92,2.9-7.85,5.78-11.76,8.68a1.71,1.71,0,0,1-1.4.32L6.27,28.25a2.42,2.42,0,0,0-.38,0H1.06C.33,28.23,0,27.9,0,27.18V20.49c0-.73.33-1.06,1.05-1.06H5.53a.79.79,0,0,0,.6-.22,6.43,6.43,0,0,1,2.46-1.55,6,6,0,0,1,6.14,1.25,1.89,1.89,0,0,0,1.42.53c.67,0,1.35,0,2,0a2.76,2.76,0,0,1,2.48,1.06l.26-.16c.93-.62,1.87-1.25,2.81-1.86a4.47,4.47,0,0,1,6,1c.09.12.17.26.25.39ZM27.74,20a.16.16,0,0,0,0-.06l-.08-.05a2.66,2.66,0,0,0-3,.1c-1,.63-1.93,1.28-2.91,1.91-.36.23-.71.45-.71.94a.19.19,0,0,1,0,.08,2.65,2.65,0,0,1-2.61,1.81h-7a.88.88,0,0,1,0-1.75h7a.88.88,0,1,0,0-1.76,15.26,15.26,0,0,0-1.79,0A4.24,4.24,0,0,1,13.31,20a4.11,4.11,0,0,0-4.38-.64A6,6,0,0,0,7,20.76a1.56,1.56,0,0,1-1.16.43c-1.26,0-2.52,0-3.78,0H1.78v5.28H6a2.42,2.42,0,0,1,.38,0l9.89,1.7a.59.59,0,0,0,.53-.13l10.71-7.88Z" />
        <path d="M15,0A8,8,0,1,1,7.09,8,8,8,0,0,1,15,0Zm.88,1.84c0,.63,0,1.24,0,1.86a.39.39,0,0,0,.26.41,2.57,2.57,0,0,1,1.49,2.35.85.85,0,0,1-.82.89.87.87,0,0,1-.92-.79,1.64,1.64,0,0,0-.05-.32.86.86,0,0,0-1-.62.87.87,0,0,0,0,1.72l.44,0a2.64,2.64,0,0,1,.77,5,.31.31,0,0,0-.18.21c0,.48,0,1,0,1.44a6.18,6.18,0,0,0,0-12.22Zm-1.76,0a6.18,6.18,0,0,0,0,12.22c0-.42,0-.84,0-1.26a.39.39,0,0,0-.28-.43A2.58,2.58,0,0,1,12.36,10a.86.86,0,0,1,.76-.87c.54-.07.93.29,1,.93a.86.86,0,0,0,.88.81.87.87,0,0,0,.13-1.73c-.15,0-.29,0-.44-.05a2.51,2.51,0,0,1-2.15-1.7,2.59,2.59,0,0,1,1.39-3.33c.08,0,.18-.14.18-.21C14.13,3.18,14.12,2.52,14.12,1.84Z" />
      </g>
    </g>
  </svg>
);

export const TotalSalesIcon = ({ size, color, ...props }) => (
  <Icon
    style={{
      display: "inline-block",
      width: size,
      height: size,
      color: color,
    }}
    component={TotalSales}
    {...props}
  />
);

const AverageSale = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 29.73 31.55"
    >
      <defs></defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M1.38,16.11.07,16v-.89L1.35,15V12.07L.06,12v-.9l1.3-.1V8L.08,7.93V7l1.29-.11V4L.08,3.9V3l1.33-.12V.06l1-.06V30.53h2l.07-1h.92l.09,1h2l.12-1h.87l.12,1h2l.08-1h.91l.1,1h2l.06-1h.93l.09,1h2l.12-1h.88l.11,1h2l.09-1h.91l.09,1h2l.07-1h.92l.09,1h2l.12-1h.87l.12,1h2.41v1h-28V28.22L.06,28.11v-.9l1.3-.1V24.19L.08,24.08,0,23.2l1.37-.14V20.15L.06,20l0-.88L1.38,19Z" />
          <path d="M18.73,24.67a1.53,1.53,0,0,1-1.48,2,1.73,1.73,0,0,1-1.66-1.92,1.22,1.22,0,0,0-.32-.83c-.74-.72-1.62-1.32-2.29-2.09A2.58,2.58,0,0,0,10.54,21a1,1,0,0,0-.57.28c-1,.93-2,1.87-3,2.84a1.18,1.18,0,0,0-.26.84,1.68,1.68,0,0,1-1,1.8,1.56,1.56,0,0,1-1.92-.34,1.54,1.54,0,0,1-.3-1.86,1.68,1.68,0,0,1,1.79-.95,1.54,1.54,0,0,0,1-.32c.95-.83,1.83-1.73,2.76-2.58a.9.9,0,0,0,.35-1A1.49,1.49,0,0,1,10.18,18a1.55,1.55,0,0,1,1.75,0,1.7,1.7,0,0,1,.8,1.72,1.3,1.3,0,0,0,.34.9c.91.87,1.85,1.71,2.82,2.51.25.2.67.18,1,.28,1.32.39,1.93-.64,2.67-1.37l4.9-4.84a1,1,0,0,0,.36-1.07,1.63,1.63,0,0,1,1.48-2,1.67,1.67,0,0,1,1.82,1.66,1.6,1.6,0,0,1-1.79,1.66,1.21,1.21,0,0,0-1.21.45c-1.94,2-3.9,3.86-5.83,5.81A4.2,4.2,0,0,0,18.73,24.67Z" />
          <path d="M20.73,12.06A3.54,3.54,0,1,1,17.2,8.55,3.54,3.54,0,0,1,20.73,12.06Z" />
          <path d="M26.92,11.11l1.44.47-2,1.71-1.47-1.77L26,11V8.16h1Z" />
          <path d="M10.77,15.9,9.16,14.22l1.19-.62V10.78l1,0v2.95l1.27.43Z" />
          <path d="M17.19,21.42l-1.82-1.76,1.3-.61V16.2h1v2.93L19,19.6Z" />
          <path
            class="cls-1"
            d="M16.19,12.68H17s0,0,0,.05a.48.48,0,0,0,.45.2c.21,0,.39-.14.39-.26s-.18-.24-.41-.25A1.5,1.5,0,0,1,16.34,12c-.36-.4-.06-.88.63-1.06.05,0,.06,0,.06,0v-.22s0,0,.08,0h.69c.07,0,.08,0,.08,0s0,.14,0,.21,0,0,.08.07c.47.12.72.34.77.66v0H17.9a1.71,1.71,0,0,0-.11-.14.57.57,0,0,0-.5-.09c-.18.05-.28.16-.25.27a.41.41,0,0,0,.4.22,2,2,0,0,1,.8.16c.76.36.59,1.09-.3,1.31q-.07,0-.06.06a1.77,1.77,0,0,0,0,.23s0,0-.07,0h-.72c-.05,0-.06,0-.06,0v-.22s0,0-.07-.06c-.49-.13-.73-.36-.77-.67Z"
          />
          <path d="M14.73,6.06A3.54,3.54,0,1,1,11.2,2.55,3.54,3.54,0,0,1,14.73,6.06Z" />
          <path
            class="cls-1"
            d="M10.19,6.68H11s0,0,0,.05a.48.48,0,0,0,.45.2c.21,0,.39-.14.39-.26s-.18-.24-.41-.25A1.5,1.5,0,0,1,10.34,6C10,5.61,10.28,5.13,11,5c0,0,.06,0,.06,0V4.68s0,0,.08,0h.69c.07,0,.08,0,.08,0s0,.14,0,.21,0,.05.08.07c.47.12.72.34.77.66v0H11.9a1.71,1.71,0,0,0-.11-.14.57.57,0,0,0-.5-.09c-.18,0-.28.16-.25.27a.41.41,0,0,0,.4.22,2,2,0,0,1,.8.16c.76.36.59,1.09-.3,1.31q-.07,0-.06.06a1.77,1.77,0,0,0,0,.23s0,0-.07,0h-.72c-.05,0-.06,0-.06,0V7.44s0-.05-.07-.06c-.49-.13-.73-.36-.77-.67Z"
          />
          <path d="M29.73,4.06a3.54,3.54,0,1,1-7.08.06,3.54,3.54,0,0,1,7.08-.06Z" />
          <path
            class="cls-1"
            d="M25.19,4.68H26s0,0,0,.05a.48.48,0,0,0,.45.2c.21,0,.39-.14.39-.26s-.18-.24-.41-.25A1.5,1.5,0,0,1,25.34,4C25,3.61,25.28,3.13,26,3c.05,0,.06,0,.06-.05V2.68s0-.05.08-.05h.69c.07,0,.08,0,.08.05s0,.14,0,.21,0,0,.08.07c.47.12.72.34.77.66v0H26.9a1.71,1.71,0,0,0-.11-.14.57.57,0,0,0-.5-.09c-.18.05-.28.16-.25.27a.41.41,0,0,0,.4.22,2,2,0,0,1,.8.16c.76.36.59,1.09-.3,1.31q-.07,0-.06.06a1.77,1.77,0,0,0,0,.23s0,0-.07,0h-.72c-.05,0-.06,0-.06,0V5.44s0-.05-.07-.06c-.49-.13-.73-.36-.77-.67Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const AverageSaleIcon = ({ size, color, ...props }) => (
  <Icon
    style={{
      display: "inline-block",
      width: size,
      height: size,
      color: color,
    }}
    component={AverageSale}
    {...props}
  />
);
